/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setOrderingMenuAssignments} from '../api'

export const useMutationSetOrderingMenuAssignments = createReactQueryMutationHook('setOrderingMenuAssignments', setOrderingMenuAssignments)
